module.exports = __webpack_public_path__ + "static/media/card_img.f3b287cb.svg";